<script lang="ts">
  import type { GlobalProperties } from 'customer-components/lib/types';

  export let href: string | null = null;
  export let type: 'button' | 'reset' | 'submit' = 'button';
  export let variant: 'ghost' | 'secondary' | 'accent' | null = null;
  export let size: 'small' | 'large' | null = null;
  export let disabled = false;
  export let width: number | null = null;
  export let isFullWidth = false;
  export let borderRadius: GlobalProperties['borderRadius'];

  $: style = `
    border-radius: ${borderRadius};
    ${width && `width:${width}px;`}
  `;
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
  this={href ? 'a' : 'button'}
  {href}
  {type}
  {disabled}
  class="button"
  class:is-ghost={variant === 'ghost'}
  class:is-secondary={variant === 'secondary'}
  class:is-accent={variant === 'accent'}
  class:is-small={size === 'small'}
  class:is-large={size === 'large'}
  class:is-fullwidth={isFullWidth}
  {style}
  on:click
>
  <slot />
</svelte:element>

<style>
  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--spacing-micro);
    flex-shrink: 0;
    width: fit-content;
    height: 3rem;
    padding: var(--spacing-small-xl) var(--spacing-micro);
    border: none;
    background-color: var(--vlt-lp-primary);
    color: var(--vlt-lp-primary-text);
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    letter-spacing: 0.16px;
    text-decoration: none;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 6px 16px;
  }

  .button:disabled {
    touch-action: none;
    cursor: not-allowed;
    background: var(--color-background);
    color: var(--neutral-extra-light) !important;
    border: 1px solid var(--color-background);
  }

  .button.is-ghost {
    gap: var(--spacing-small-xl);
    padding: var(--spacing-small-xl) 0;
    color: var(--text-text-primary);
    background-color: transparent;
    font-size: 14px;
  }

  .button.is-secondary {
    color: var(--text-text-primary);
    border: 1px solid var(--border-border-primary);
    background: var(--fill-fill-white);
  }

  .button.is-accent {
    color: var(--vlt-lp-accent-text);
    border: 1px solid var(--vlt-lp-accent);
    background: var(--vlt-lp-accent);
  }

  .button.is-small {
    height: unset;
    padding: var(--spacing-small-xl) var(--spacing-middle-md);
    font-size: 14px;
    letter-spacing: 0.14px;
  }

  .button.is-large {
    padding: var(--spacing-small-xl) 32px;
  }

  .button.is-fullwidth {
    width: 100%;
  }
</style>
